import { render, staticRenderFns } from "./experiment.vue?vue&type=template&id=4e542d8f&scoped=true&"
import script from "./experiment.vue?vue&type=script&lang=js&"
export * from "./experiment.vue?vue&type=script&lang=js&"
import style0 from "./experiment.vue?vue&type=style&index=0&id=4e542d8f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e542d8f",
  null
  
)

export default component.exports